import React from 'react';
import PropTypes from 'prop-types';

import {
  START_DATE,
} from '@zr/utilities/profileFields';

import { STRING_FIELD_START_YEAR } from '../labels';

import FormikLabeledField from './FormikLabeledField';
import YearOptions from '../YearOptions';

import formikPropTypes from './formikPropTypes';

export function StartYearField({
  name, formikProps,
}) {
  const { errors } = formikProps;

  return (
    <FormikLabeledField
      as="select"
      // since the profile field is the date combined, also display errors with that field
      error={errors[name] || errors[START_DATE]}
      formikProps={formikProps}
      name={name}
      label={STRING_FIELD_START_YEAR}
      placeholder={STRING_FIELD_START_YEAR}
    >
      <YearOptions />
    </FormikLabeledField>
  );
}

StartYearField.propTypes = {
  name: PropTypes.string.isRequired,
  formikProps: formikPropTypes.isRequired,
};

export default StartYearField;
